import React from 'react';
import HSTable from '../../../../../../../common/HSTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../store/rootReducer';
import { Guarantees } from '../../../../../redux/types';
import { Empty, Spin } from 'antd';

const GuaranteesTableView: React.FC = () => {
    const loading = useSelector((state: RootState) => state.investments.gLoading);
    const list = useSelector((state: RootState) => state.investments.guarantees);

    const columns = [
        {
            dataIndex: 'guarantorLegalName',
            title: 'Guarantor Legal Name',
        },
        {
            dataIndex: 'guaranteeType',
            title: 'Type of guarantee',
        },
    ];
    return (
        <div>
            {!loading && list.length > 0 && (
                <HSTable columns={columns} data={list} loading={loading} rowKey={(d: Guarantees) => d.uuid} />
            )}
            {!loading && list.length === 0 && (
                <div>
                    <Empty description={`No Guarantees Data`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            )}
            {loading && (
                <div className="flex justify-center items-center py-4">
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default GuaranteesTableView;
